//#region INTERFACE ICrudOptions
export interface ICrudOptions {
  canEdit?: boolean;
  canSubmit?: boolean;
  canView?: boolean;
  isEdited?: boolean;
  submit?: boolean;
}

//#endregion

//#region CONST _DEFAULT_CRUD_OPTIONS
export const _DEFAULT_CRUD_OPTIONS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
  submit: false,
};
//#endregion